<template>
  <div class="formDetailReportComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="col-10">
      <div class="ContainerRecordatorio">
        <div class="ContainerRecorda">
          <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
          <p>
            <span>
              {{ $t('report.label.affiliatesBotStars.description') }}
            </span>
          </p>
        </div>
        <v-form ref="formulario" lazy-validation class="mt-5 col-8">
          <div class="formReport">
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-sm-2">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  color="secondary"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedStartDate"
                      :label="'*'+$t('novelties.label.startDate')"
                      color="secondary"
                      :rules="startDateRules"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="localStartDate"
                    color="primary"
                    :max="hoy"
                    @change="handleStartDateChange"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" class="pl-sm-2">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  color="secondary"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndDate"
                      :label="'*'+$t('novelties.label.endDate')"
                      color="secondary"
                      :rules="endDateRules"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="localEndDate"
                    color="primary"
                    :max="hoy"
                    :min="formData.startDate"
                    @change="handleEndDateChange"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </div>
    </div>

    <!-- Botón flotante de descarga -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="submitForm"
          style="margin-bottom: 70px; z-index: 1000;"
          ><v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.download') }}</span>
    </v-tooltip>

    <!-- Botón flotante de envío por correo -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          bottom
          right
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="sendEmailForm"
          style="z-index: 1000;"
          ><v-icon dark>mdi-email</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.send') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { service as reports_service } from "@/services/reports_service.js";
import Swal from "sweetalert2";
import i18n from '@/plugins/i18n';

export default {
  name: "formAffiliatesBotStarsComponent",
  props: {
    report: {
      required: true,
    },
  },
  data() {
    return {
      formData: {
        startDate: null,
        endDate: null,
      },
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      formattedStartDate: '',
      formattedEndDate: '',
      loading: false,
      showErrorMessages: false,
      dialog: false,
      startDateRules: [
        v => !!v || this.$t('novelties.label.startDate.required'),
      ],
      endDateRules: [
        v => !!v || this.$t('novelties.label.endDate.required'),
      ],
    };
  },
  computed: {
    // Fecha máxima permitida (hoy)
    hoy() {
      const today = new Date();
      return today.toISOString().split('T')[0];
    }
  },
  methods: {
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      
      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.formattedStartDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
        icon: "error",
        title: i18n.t('label.date.invalid'),
        text: i18n.t('label.startDate.invalid.text4'),
        });
        this.localStartDate = null;
        this.formattedStartDate = "";
        this.formData.startDate = null;
        return;
      }

      if(this.formData.endDate != null){
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text3'),
          });
          this.localStartDate = null;
          this.formattedStartDate = "";
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.formattedEndDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.localStartDate) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.endDate.invalid.text1'),
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      
      if (selectedDate > today) {
        Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.endDate.invalid.text3')
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join("<br>");
          Swal.fire({
            icon: "error",
            title: i18n.t('label.errorsValidation.plural.title'),
            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });
          return;
        }

        this.loading = true;
        try {
          const response = await reports_service.generateAffiliatesBotStarsReport(
            sessionStorage.getItem("idGroup"),
            sessionStorage.getItem("idEmpresa"),
            sessionStorage.getItem("idUsuario"),
            this.formData.startDate,
            this.formData.endDate
          );
          
          if (response.data && response.data.payload) {
            if (response.data.payload.url != null) {
              this.downloadExcelFile(response.data.payload.url);
            } else {
              Swal.fire({
                icon: "info",
                title: i18n.t('report.label.downloadExcel.title'),
                text: response.data.payload.message || 'No hay información para descargar',
              });
              return;
            }
          }
        } catch (error) {
          console.error(i18n.t('report.label.downloadExcel.error'));
        } finally {
          this.loading = false;
        }
      } catch (error) {
        console.error('Error en submitForm:', error);
      }
    },

    async sendEmailForm() {
      try {
        if (this.showValidationErrorsIfAny()) return;

        const result = await Swal.fire({
          icon: "info",
          title: i18n.t('report.label.sendEmailConfirm.title'),
          text: i18n.t('report.label.sendEmailResults.text') + ' ' + atob(sessionStorage.getItem('email')),
          showCancelButton: true,
          confirmButtonText: i18n.t('button.accept.text'),
          confirmButtonColor: '#6E17A5'
        });

        if (result.isConfirmed) {
          await this.sendAffiliatesBotStarsReportEmail();
        }
      } catch (error) {
        console.error('Error en sendEmailForm:', error);
      }
    },

    showValidationErrorsIfAny() {
      const validationErrors = this.validateForm();
      if (Object.keys(validationErrors).length === 0) return false;

      const errorMessages = Object.values(validationErrors).join("<br>");
      Swal.fire({
        icon: "error",
        title: i18n.t('label.errorsValidation.plural.title'),
        html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
        confirmButtonColor: '#6E17A5'
      });
      return true;
    },

    async sendAffiliatesBotStarsReportEmail() {
      this.loading = true;
      try {
        const response = await reports_service.sendAffiliatesBotStarsReportEmail(
          sessionStorage.getItem("idGroup"),
          sessionStorage.getItem("idEmpresa"),
          sessionStorage.getItem("idUsuario"),
          this.formData.startDate,
          this.formData.endDate
        );

        const message = response.status === 202 || !response.data?.payload?.message
          ? i18n.t('report.label.email.processing')
          : response.data.payload.message;

        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: message,
          showConfirmButton: false,
          timer: 2500
        });
      } catch (error) {
        this.handleSendEmailError(error);
      } finally {
        this.loading = false;
      }
    },

    handleSendEmailError(error) {
      console.error('Error en sendEmailForm:', error);
      if (error.status === 202) {
        Swal.fire({
          position: 'top-end',
          icon: 'info',
          title: error.data?.payload?.message || i18n.t('report.label.email.processing'),
          showConfirmButton: false,
          timer: 2500
        });
      } else {
        Swal.fire({
          icon: "error",
          title: 'ERROR',
          text: error.response?.data?.payload?.message || error.data?.payload?.message || i18n.t('report.label.errorText'),
          confirmButtonColor: '#6E17A5'
        });
      }
    },

    downloadExcelFile(responseUrl) {
      // Crear enlace y descargar directamente
      const link = document.createElement('a');
      link.href = responseUrl;
      link.target = '_blank';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    validateForm() {
      const errors = {};
      
      if (!this.formData.startDate) {
        errors.startDate = this.$t('novelties.label.startDate.required');
      }
      
      if (!this.formData.endDate) {
        errors.endDate = this.$t('novelties.label.endDate.required');
      }
      
      if (this.formData.startDate && this.formData.endDate) {
        const start = new Date(this.formData.startDate);
        const end = new Date(this.formData.endDate);
        
        if (start > end) {
          errors.dateRange = this.$t('label.startDate.invalid.text3');
        }
        
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (start > today) {
          errors.startDate = this.$t('label.startDate.invalid.text4');
        }
        
        if (end > today) {
          errors.endDate = this.$t('label.endDate.invalid.text3');
        }
      }
      
      return errors;
    },
  },
};
</script>

<style scoped>
.formDetailReportComponent {
  display: flex;
  justify-content: center;
}

.formReport {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.swal-subtitle {
  font-size: 14px;
  margin-bottom: 10px;
  color: #666;
}
</style>
